import * as Api from '@ViewModels';
import { IVolunteerFilter, IVolunteerFilterCriteria, VolunteerFilterProperty } from './models';

const fromCriteria = (criteria: IVolunteerFilterCriteria[]): IVolunteerFilter =>
	criteria.length > 0 ? { criteria, op: Api.FilterOperator.And } : {};

export const buildActivityFilter = (activityId: string): IVolunteerFilter =>
	fromCriteria(activityId ? [{ property: VolunteerFilterProperty.Activity, value: activityId }] : []);

export const buildContactFilter = (contactId: string): IVolunteerFilter =>
	fromCriteria(contactId ? [{ property: VolunteerFilterProperty.ContactId, value: contactId }] : []);

export const buildDateWindowFilter = ({ from, to }: { from?: string; to?: string }): IVolunteerFilter =>
	fromCriteria([
		...(from ? [{ property: VolunteerFilterProperty.Date, op: Api.FilterOperator.Gt, value: from }] : []),
		...(to ? [{ property: VolunteerFilterProperty.Date, op: Api.FilterOperator.Lt, value: to }] : []),
	]);

export const combineVolunteerFilters = (...filters: IVolunteerFilter[]): IVolunteerFilter =>
	fromCriteria(filters.flatMap(filter => filter.criteria ?? []));
